import React from "react";
import { useLocation } from "react-router-dom";

import { useCorporateMode } from "context/CorporateModeContext";

const CorporateBar = () => {
  const { isCorporate, exitCorporateMode } = useCorporateMode();
  const location = useLocation();
  const shouldHideOnRoute = location.pathname === "/";

  if (!isCorporate || shouldHideOnRoute) {
    return null;
  }

  return (
    <div
      className="w-full z-[200] relative px-4 py-2.5 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-center border-b border-white/10"
      style={{
        background:
          "linear-gradient(135deg, #1e1b24 0%, #2d2640 50%, #1a2535 100%)",
        color: "rgba(255, 248, 245, 0.95)",
      }}
      role="banner"
    >
      <span className="text-sm md:text-base font-semibold tracking-wide lowercase">
        for corporates
      </span>
      <button
        type="button"
        onClick={exitCorporateMode}
        className="text-xs md:text-sm font-normal lowercase text-[var(--peachy-pink)] hover:opacity-90 underline underline-offset-2 bg-transparent border-0 cursor-pointer p-0"
      >
        not a corporate company?
      </button>
    </div>
  );
};

export default CorporateBar;
